import Vue from 'vue';
import filters from './factory.js';

for(let key in filters) {
    Vue.filter(key, filters[key]);
}